import {
  addObj,
  getAll,
  getPage,
  getDetail,
  resetAllReportInterval,
} from '@/api/jt808deviceserv'

export default {
  state: {
    state_Jt808Device_AddObjResult: null,
    state_Jt808Device_GetAllResult: null,
    state_Jt808Device_GetPageResult: null,
    state_Jt808Device_GetDetailResult: null,
    state_Jt808Device_ResetAllReportIntervalResult: null,
  },
  mutations: {
    SET_JT808DEVICE_ADDOBJ_RESULT: (state, rst) => {
      state.state_Jt808Device_AddObjResult = rst;
    },
    SET_JT808DEVICE_GETALL_RESULT: (state, rst) => {
      state.state_Jt808Device_GetAllResult = rst;
    },
    SET_JT808DEVICE_GETPAGE_RESULT: (state, rst) => {
      state.state_Jt808Device_GetPageResult = rst;
    },
    SET_JT808DEVICE_GETDETAIL_RESULT: (state, rst) => {
      state.state_Jt808Device_GetDetailResult = rst;
    },
    SET_JT808DEVICE_RESETALLREPORTINTERVAL_RESULT: (state, rst) => {
      state.state_Jt808Device_ResetAllReportIntervalResult = rst;
    },
  },
  actions: {
    Jt808DeviceServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_JT808DEVICE_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_JT808DEVICE_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    Jt808DeviceServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_JT808DEVICE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_JT808DEVICE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    Jt808DeviceServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_JT808DEVICE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_JT808DEVICE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    Jt808DeviceServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_JT808DEVICE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_JT808DEVICE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    Jt808DeviceServ_ResetAllReportInterval({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        resetAllReportInterval(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_JT808DEVICE_RESETALLREPORTINTERVAL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_JT808DEVICE_RESETALLREPORTINTERVAL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Jt808Device_AddObjResult: state => {
      return state.state_Jt808Device_AddObjResult;
    },
    get_Jt808Device_GetAllResult: state => {
      return state.state_Jt808Device_GetAllResult;
    },
    get_Jt808Device_GetPageResult: state => {
      return state.state_Jt808Device_GetPageResult;
    },
    get_Jt808Device_GetDetailResult: state => {
      return state.state_Jt808Device_GetDetailResult;
    },
    get_Jt808Device_ResetAllReportIntervalResult: state => {
      return state.state_Jt808Device_ResetAllReportIntervalResult;
    },
  }
}